import { axiosBasic } from "../../../../api/axios";
import { config } from "../../../../api/endPoints";

const { SuperAdmin } = config.REST_API;

export const getSuperAdminDashboard = () =>
  axiosBasic.get(SuperAdmin.Dashboard).then((res) => res.data);

export const getSuperAdminCompanies = () =>
  axiosBasic.get(SuperAdmin.Companies).then((res) => res.data);

export const getSuperAdminUsers = (params = {}) =>
  axiosBasic
    .get(SuperAdmin.Users, {
      params: {
        search: params.search || undefined,
        companyId: params.companyId || undefined,
        page: params.page || 1,
        pageSize: params.pageSize || 50,
      },
    })
    .then((res) => res.data);

export const getSuperAdminPayments = (params = {}) =>
  axiosBasic
    .get(SuperAdmin.Payments, {
      params: {
        companyId: params.companyId || undefined,
        page: params.page || 1,
        pageSize: params.pageSize || 50,
      },
    })
    .then((res) => res.data);

export const getSuperAdminTickets = (params = {}) =>
  axiosBasic
    .get(SuperAdmin.Tickets, {
      params: {
        search: params.search || undefined,
        companyId: params.companyId || undefined,
        status: params.status === "" || params.status === null || params.status === undefined
          ? undefined
          : params.status,
        priority: params.priority === "" || params.priority === null || params.priority === undefined
          ? undefined
          : params.priority,
        page: params.page || 1,
        pageSize: params.pageSize || 50,
      },
    })
    .then((res) => res.data);

export const getSuperAdminTicket = (id) =>
  axiosBasic.get(`${SuperAdmin.TicketById}/${id}`).then((res) => res.data);

export const addSuperAdminTicketComment = (payload) =>
  axiosBasic.post(SuperAdmin.TicketComments, payload).then((res) => res.data);

export const updateSuperAdminTicket = (payload) =>
  axiosBasic.post(SuperAdmin.TicketUpdate, payload).then((res) => res.data);
